import { useState } from 'react';

export default function CourseStructureTree({ data }) {
  return (
    <div className="p-4 space-y-6">
      {data.map((course) => (
        <CourseNode key={course.parentId} node={course} level={0} />
      ))}
    </div>
  );
}

function CourseNode({ node, level }) {
  const [isOpen, setIsOpen] = useState(false);
  const indent = level * 20;

  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <div
      className="border rounded-lg shadow-sm p-4"
      style={{ marginLeft: `${indent}px` }}
    >
      <button
        style={{ backgroundColor: 'transparent', color: 'black' }}
        onClick={toggleOpen}
        className="flex items-center justify-between w-full text-left px-2 py-1 rounded hover:bg-gray-200 bg-white text-gray-800 border"
      >
        <span className="text-lg font-medium text-black">{node.name}</span>
        <span className="text-sm">{isOpen ? '➖' : '➕'}</span>
      </button>

      {isOpen && (
        <div className="mt-3">
          {node.content?.length > 0 && (
            <div className="mb-3">
              <p className="text-md font-medium">Content:</p>
              <ul className="list-disc list-inside ml-4">
                {node.content.map((item, idx) => (
                  <li key={idx} className="mt-1">
                    {item.fileUrl.endsWith('.m3u8') ? (
                      <button
                        onClick={() => {
                          const encodedUrl = encodeURIComponent(item.fileUrl);
                          const encodedName = encodeURIComponent(item.contentName);
                         window.open(
                                `/dashboard/m3u8-player.html?url=${encodedUrl}`,
                                "_blank"
                              );
                        }}
                        className="underline text-gray-700 hover:text-gray-900"
                      >
                        {item.contentName}
                      </button>
                    ) : (
                      <a
                        href={item.fileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline text-gray-700 hover:text-gray-900"
                      >
                        {item.contentName}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {node.children?.length > 0 && (
            <div className="mt-2">
              {node.children.map((child) => (
                <CourseNode key={child.parentId} node={child} level={level + 1} />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
